/**
 * Environment Configuration
 * Access environment variables with proper defaults
 */

/**
 * Express mounts all JSON APIs under `/api`. If REACT_APP_API_URL is set to the server root
 * (e.g. http://backend:5001 or http://localhost:5001), requests hit `/public/...` instead of
 * `/api/public/...` and the server responds with `{ message: 'Route not found' }`.
 */
function normalizeApiUrl(raw) {
    const fallback = 'http://localhost:5001/api';
    if (!raw || typeof raw !== 'string') return fallback;
    const trimmed = raw.trim().replace(/\/+$/, '');
    try {
        const url = new URL(trimmed);
        const path = (url.pathname || '/').replace(/\/+$/, '') || '/';
        if (path === '/' || path === '') {
            url.pathname = '/api';
            return url.toString().replace(/\/+$/, '');
        }
        return trimmed;
    } catch {
        return fallback;
    }
}

function normalizeSocketUrl(raw, apiUrl) {
    if (raw && typeof raw === 'string' && raw.trim()) {
        return raw.trim().replace(/\/+$/, '');
    }
    try {
        const url = new URL(apiUrl);
        url.pathname = url.pathname.replace(/\/api\/?$/, '') || '/';
        return url.origin;
    } catch {
        return 'http://localhost:5001';
    }
}

const normalizedApiUrl = normalizeApiUrl(process.env.REACT_APP_API_URL || 'http://localhost:5001/api');

const config = {
    // API Configuration (always ends with .../api — no trailing slash)
    apiUrl: normalizedApiUrl,
    socketUrl: normalizeSocketUrl(process.env.REACT_APP_SOCKET_URL, normalizedApiUrl),
    websiteUrl: process.env.REACT_APP_WEBSITE_URL || (process.env.NODE_ENV === 'production' ? 'https://testgate.io' : 'http://localhost:3000'),

    // Private Keys
    googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
    stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',

    // Feature Flags
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableDebug: process.env.REACT_APP_ENABLE_DEBUG === 'true',

    // Environment
    env: process.env.REACT_APP_ENV || 'development',
    isDevelopment: process.env.REACT_APP_ENV === 'development' || !process.env.REACT_APP_ENV,
    isProduction: process.env.REACT_APP_ENV === 'production',
};

export const { websiteUrl, apiUrl, socketUrl } = config;
export default config;
